export const getTextColor = (songHasStatus: boolean, isLoading?: boolean): string => {
  if (songHasStatus || isLoading) {
    return 'text.secondary'
  }
  return 'text.primary'
}

export const getCurrencySymbol = (currencyName: string | null): string => {
  switch (currencyName) {
    case 'US Dollar':
      return '$'
    case 'British Pound':
      return '£'
    case 'Euro':
      return '€'
    default:
      return '$' // Default to USD
  }
}
